import dayjs from 'dayjs';

export const addDateRange = (params, dateRange, propName) => {
    const searchValue = params;
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    
    const startDate = dateRange[0] ? dayjs(dateRange[0]).format('YYYY-MM-DD HH:mm:ss') : undefined;
    const endDate = dateRange[1] ? dayjs(dateRange[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined;

    if (typeof (propName) === 'undefined') {
      searchValue['beginTime'] = startDate;
      searchValue['endTime'] = endDate;
    } else {
      searchValue[propName + 'Start'] = startDate;
      searchValue[propName + 'End'] = endDate;
    }
    return searchValue;
};